import { COLLISION_COLOURS } from '../../../constants/Constants';
import { CollisionCollider } from '../collisions/CollisionCollider';

export class WorldCollider extends Phaser.GameObjects.Zone {
  constructor(scene, layer, config) {
    super(scene, config.x, config.y, config.width, config.height);
    layer.add(this);
    this.type = 'collider';
    this._bodyCollider = new CollisionCollider(this.scene, {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      gameObject: this,
      debugColour: COLLISION_COLOURS.SOLID,
    });
  }

  destroy() {
    this._bodyCollider.destroy();
    this._bodyCollider = null;
    super.destroy();
  }
}
